<div class="container py-5 d-flex align-items-center justify-content-center">
  <div class="card shadow-lg p-4" style="max-width:420px; width:100%; border-radius:12px;">
    <h5 class="mb-3 text-theme">Send a Gift</h5>
    <p class="text-muted mb-3">Enter the amount you'd like to send as a gift (in ₹).</p>

    <form (submit)="onSubmit(amountInput.value); $event.preventDefault();" novalidate>
      <div class="mb-3">
        <label for="amount" class="form-label">Amount (₹)</label>
        <input
          id="amount"
          #amountInput
          class="form-control"
          type="number"
          min="1"
          step="1"
          placeholder="Enter amount in rupees"
          [disabled]="loading || !online"
          [(ngModel)]="amount"
          name="amount"
          [ngModelOptions]="{standalone: true}"
          required
        />
        <div class="preset-amounts mt-2 d-flex gap-2">
          <button type="button" class="btn btn-sm btn-outline-secondary" *ngFor="let a of presetAmounts" (click)="selectAmount(a)">₹{{a}}</button>
        </div>
      </div>

      <div class="note-inline mb-3">
        <p class="mb-1">Gift payment. No invoice will be issued.</p>
        <p class="mb-2">A payment acknowledgement will be provided after successful payment.</p>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="ack" [(ngModel)]="acknowledged" name="ack" [ngModelOptions]="{standalone: true}" [disabled]="!online || loading">
          <label class="form-check-label" for="ack">I agree</label>
        </div>
      </div>

      <div class="d-flex gap-2 pay-actions align-items-center">
          <button type="submit" class="btn btn-theme flex-fill" [disabled]="loading || !online || !acknowledged || !amount">
            {{ loading ? 'Processing...' : (online ? 'Pay' : 'Offline') }}
          </button>
          <a [routerLink]="['/', tenantService.getTenantKey()]" class="btn btn-outline-secondary">Cancel</a>
      </div>
    </form>
  </div>
</div>
